<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { useModal } from 'vue-final-modal'

import Auth from '~/components/modal-windows/Auth.vue'
import AuthAction from '~/enums/auth-action'
import Page from '~/enums/page'
import formatter from '~/helpers/formatter'
import { useAuthStore } from '~/store/auth'
import { useProductsStore } from '~/store/products'
import { useUserStore } from '~/store/user'

const route = useRoute()
const authStore = useAuthStore()
const productsStore = useProductsStore()
const userStore = useUserStore()

const { hasAccessToAdminPanel, isSupplier } = storeToRefs(userStore)

const items = computed(() => {
  const { cartTotalItems, wishListTotalItems } = productsStore
  const items = [
    {
      badgeText: null,
      icon: 'outlined/home',
      isAuthRequired: false,
      path: Page.Main,
      title: 'Главная'
    },
    {
      badgeText: null,
      icon: 'outlined/grid-view',
      isAuthRequired: false,
      path: Page.Search,
      title: 'Каталог'
    },
    {
      badgeText: cartTotalItems === 0 ? null : formatter.formatBadgeText(cartTotalItems),
      icon: 'outlined/shopping-cart',
      isAuthRequired: false,
      path: Page.Cart,
      title: 'Корзина'
    },
    {
      badgeText: wishListTotalItems === 0 ? null : formatter.formatBadgeText(wishListTotalItems),
      icon: 'outlined/favorite-border',
      isAuthRequired: false,
      path: Page.Favorites,
      title: 'Избранное'
    }
  ]

  let lastItem

  if (authStore.isUser) {
    let extraProps

    switch (true) {
      case hasAccessToAdminPanel.value:
        extraProps = { icon: 'outlined/display-settings', path: Page.Admin, title: 'АП' }
        break
      case isSupplier.value:
        extraProps = { icon: 'outlined/display-settings', path: Page.Supplier, title: 'ЛКП' }
        break
      default:
        extraProps = { icon: 'outlined/account-circle', path: Page.Account, title: 'ЛК' }
        break
    }

    lastItem = { badgeText: null, isAuthRequired: true, ...extraProps }
  } else {
    lastItem = {
      badgeText: null,
      icon: 'outlined/account-circle',
      isAuthRequired: true,
      path: Page.Account,
      title: 'Вход'
    }
  }

  items.push(lastItem as any)

  return items
})

async function open (path: string, isAuthRequired: boolean): Promise<void> {
  if (isAuthRequired && !authStore.isUser) {
    await useModal({ component: Auth, attrs: { action: AuthAction.SignIn } }).open()
  } else {
    await navigateTo(path)
  }
}
</script>

<template>
  <div
    class="
      fixed inset-x-0 bottom-0 z-[999] flex h-[54px] w-full items-center justify-between bg-white px-4 pb-1 pt-1.5
      shadow-[0_-1px_2px_rgba(0,0,0,0.1)] backdrop-blur-[15px] [-webkit-backdrop-filter:blur(15px)] sm:justify-around
      md:hidden
    "
  >
    <ButtonWithBadge
      v-for="x in items"
      :key="x.path"
      :class="{
        '[&>div]:!text-main-green [&_path]:!fill-main-green': (route.path === Page.Main && x.path === Page.Main)
          || (x.path !== Page.Main && route.path.indexOf(x.path) === 0)
      }"
      :icon-name="x.icon"
      :text="x.badgeText"
      :title="x.title"
      @click="open(x.path, x.isAuthRequired)"
    />
  </div>
</template>
